module.exports = __webpack_public_path__ + "assets/polygon.98bb2e1d.svg";